const statusGiftRegisterUser = {
  ENABLE: true,
  DISABLE: false,
};

const getLabelGiftRegisterUser = () => {
  let data = {};
  data[statusGiftRegisterUser.ENABLE] = "فعال";
  data[statusGiftRegisterUser.DISABLE] = "غیرفعال";

  return data;
};

export default {
  statusGiftRegisterUser,
  getLabelGiftRegisterUser,
};
